var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var Property = /** @class */ (function () {
    function Property(target, name, min, max, multiplier) {
        if (multiplier === void 0) { multiplier = 1.0; }
        this.target = target;
        this.name = name;
        this.min = min;
        this.max = max;
        this.multiplier = multiplier;
    }
    return Property;
}());
export { Property };
export function range(prop) {
    var p = document.createElement("div");
    p.style.marginLeft = "10px";
    var label = document.createElement("label");
    var input = document.createElement("input");
    var output = document.createElement("output");
    label.htmlFor = prop.name;
    label.innerText = prop.name;
    if (prop.multiplier !== 1.0) {
        label.innerText += " (* " + prop.multiplier.toExponential() + ")";
    }
    p.appendChild(label);
    label.style.display = "inline-block";
    label.style.width = "200px";
    p.appendChild(input);
    input.style.display = "inline-block";
    input.style.verticalAlign = "middle";
    output.style.display = "inline-block";
    output.style.verticalAlign = "middle";
    p.appendChild(output);
    input.id = prop.name;
    input.type = "range";
    if (prop.min) {
        input.min = (prop.min / prop.multiplier).toString();
    }
    if (prop.max) {
        input.max = (prop.max / prop.multiplier).toString();
    }
    input.value = (prop.target[prop.name] / prop.multiplier).toString();
    output.innerText = prop.target[prop.name].toString();
    input.oninput = function (ev) {
        var val = input.value;
        var num = Number.parseFloat(val) * prop.multiplier;
        output.innerText = num.toString();
        if (prop.target) {
            prop.target[prop.name] = num;
            if (("on_" + prop.name) in prop.target) {
                prop.target["on_" + prop.name]();
            }
        }
    };
    return p;
}
export function combo(target, name, options) {
    var p = document.createElement("div");
    p.style.marginLeft = "10px";
    var label = document.createElement("label");
    label.innerText = name;
    var select = document.createElement("select");
    for (var i = 0; i < options.length; ++i) {
        var option = document.createElement("option");
        option.value = i.toString();
        option.innerText = options[i];
        select.appendChild(option);
    }
    select.value = target[name].toString();
    select.onchange = function (ev) {
        var i = Number.parseInt(select.value);
        target[name] = Number.isNaN(i) ? 0 : i;
    };
    label.appendChild(select);
    p.appendChild(label);
    return p;
}
export function group(label) {
    var e_1, _a;
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var div = document.createElement("div");
    div.innerText = label;
    div.style.marginLeft = "10px";
    try {
        for (var args_1 = __values(args), args_1_1 = args_1.next(); !args_1_1.done; args_1_1 = args_1.next()) {
            var el = args_1_1.value;
            if (el instanceof HTMLElement) {
                div.appendChild(el);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (args_1_1 && !args_1_1.done && (_a = args_1.return)) _a.call(args_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return div;
}
//# sourceMappingURL=props.js.map